<template>
    <transition name="slide-fade">
        <div class="modal" data-cy="modal_shipping_address" :class="{'open' : open}" v-if="open">
            <div class="modal-content">
                <div class="bg-white w-full rounded-sm p-5">
                    <div class="text-center text-18 font-bold text-a-blue-001b73 pt-2 pb-5" data-cy="text_modal_shipping_address_title">{{title}}</div>
                    <div class="content-height">
                        <div class="bg-a-gray-f7f7f7 rounded-[4px] text-a-gray-78787D text-14 p-2 flex items-start gap-2.5">
                            <img src="@/assets/icon/ic-warning-circle-gray.svg" alt="">
                            <div>
                                {{ lbl.shipping.info_warning }}
                            </div>
                        </div>
                        <div class="pt-5" data-cy="container_modal_shipping_address_form">
                            <FormShippingAddress
                                v-if="isLoaded"
                                ref="form-shipping"
                                :isAddress="isAddress"
                                :address="address"
                                :editAddress="editAddress"
                            ></FormShippingAddress>
                        </div>
                    </div>
                    <div class="grid grid-cols-2 gap-4 mt-5 btn" data-cy="container_modal_shipping_address_actions">
                        <button class="w-full bg-a-white-ffffff border border-a-blue-2140a6 font-bold text-a-blue-2140a6 text-18 rounded-lg py-1" data-cy="btn_modal_shipping_address_cancel" @click="hide()">{{lbl.shipping.cancel_btn}}</button>
                        <button class="w-full bg-a-blue-2140a6 text-a-white-ffffff font-bold text-18 rounded-lg py-1 " data-cy="btn_modal_shipping_address_ok" @click="clickOk()">
                            {{btnOk}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
//component
import FormShippingAddress from "./component/FormShippingAddress.vue";
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
import AuthStatusMixin from '@/mixin/AuthStatusMixin';
//service
import { RedeemShippingAddressConfigBuilder } from "@/core/Redeem/config/RedeemConfigBuilder.js";
//service
import BzbsAddressList from "@/core/Address/service/BzbsAddressList.js";
export default {
    name: "ShippingAddressModal",
    mixins: [LocaleMixin, AuthStatusMixin],
    components: {
        FormShippingAddress
    },
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,
            busModal: null,

            title: '',
            btnOk: '',
            isDefaultAddress: false,
            isAddress: [],
            isLoaded: false,
            editAddress: false,
            address: [],
            addressDetail: ''
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    watch: {
        '$route.path': function() {
            if (this.open) {
                this.hide();
            }
        },
    },
    methods: {
        show: function(config) {
            this.title = config.title;
            this.btnOk = config.btnOk;
            this.address = config.address;
            this.editAddress = config.editAddress;

            if (Util.isEmptyStr(this.btnOk)) {
                this.btnOk = this.lbl.button.ok;
            }

            if (this.isLogin) {
                this.isLoaded = false
                this.getAddress();
            }

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            this.tracking.event('campaign_delivery', 'click_cancel', null, null);

            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            // this.hide();
            // this.controller.sendCallbackOk();
            this.tracking.event('campaign_delivery', 'click_confirm', null, null);
            this.submitAddress();
        },

        submitAddress: function() {
            let address = this.$refs['form-shipping'].submitForm();
            // Util.log('shipping address', address);
            if (address != null) {
                this.onSaveShippingAddress(address)
            }
        },

        onSaveShippingAddress: function(data) {
            console.log(data);
            var builder = new RedeemShippingAddressConfigBuilder();
            if (this.editAddress) {
                builder.setAddress(data.getFullAddressText());
                builder.setAddressName(data.addressName);
                this.addressDetail = data.getFullAddressText();
            } else {
                builder.setAddress(data.getFullAddressText());
                builder.setAddressName(data.addressName);
                this.addressDetail = data.getFullAddressText();
            }
            builder.setContactNumber(data.contactNumber);
            builder.setShippingFirstName(data.firstname);
            builder.setShippingLastName(data.lastname);
            builder.setFirstName(data.firstname);
            builder.setLastName(data.lastname);
            builder.setZipcode(data.zipcode);
            builder.setIsDefault(data.isDefault);
            this.isDefaultAddress = data.isDefault;

            if (this.isDefaultAddress == true) {
                var params = {
                    firstname: data.firstname,
                    lastname: data.lastname,
                    contact_number: data.contactNumber,
                    address: this.addressDetail,
                    addressname: data.addressName,
                    zipcode: data.zipcode,
                    isdefault: data.isDefault,
                    subdistrict_code: data.subDistrictCode,
                    subdistrict_name: data.subDistrictName,
                    district_code: data.districtCode,
                    district_name: data.districtName,
                    province_code: data.provinceCode,
                    province_name: data.provinceName,
                    key: data.rowKey
                }
            }
            // var redeemShippingAddressConfig = builder.create();
            this.hide();
            this.controller.sendCallbackSaveAddress({builder: builder, params: params});
        },
        getFullAddressText: function(data) {
            var str = data.addressName + ' '
                    + data.subDistrictName + ' '
                    + data.districtName + ' '
                    + data.provinceName;
            return str;
        },
        getAddress: function () {
            BzbsAddressList.apiGetAddress().subscribe({
                next: (res) => {
                    for (let address of res) {
                        if (address.isDefault == true) {
                            this.isAddress = address;
                        }
                    }
                    this.isLoaded = true
                },
                error: (err) => {
                    console.log('err', err);
                    this.isLoaded = true
                },
            })
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import "@/style/modal.scss";

    .modal {
        @extend %modal;

        .modal-content {
            width: 400px;

            @include mobile {
                width: 100%;
                padding: 16px;
            }

            .content-height {
                overflow-y: auto;
                height: calc(100vh - 230px);
            }
        }
        .btn {
            height: 50px;
        }
    }
</style>
